import React, { useState, useEffect, useContext } from 'react'
import CustomLabel from '../../components/common/customLabel'
import useSetTitlePage from '../../hooks/useSetTitlePage'
import colors from '../../../config/colors'
import { Grid, Button, Divider, FormControl, Autocomplete, TextField, Box, Typography, Select, MenuItem } from '@mui/material'
import CustomTable from '../../components/common/customTable'
import UseIconHooks from '../../hooks/useIconHooks'
import { labelTitlePrestador } from '../../global/styles'
import * as apiService from '../../../api/index'
import DialogDetallePrestador from '../../components/consulta/prestador/dialogDetallePrestador'
import ModalLoading from '../../components/common/modalLoading'
import { useSnackbar } from 'notistack'
import { ConfigurationContext } from '../../context/configurationContext'
import {  useNavigate } from "react-router-dom";
import { PrestadorContext } from '../../context/prestadorContext'
import {columnasPrestador} from '../../collection/listas'
import { useSelector } from 'react-redux'
import { createIdTag } from '../../utils/helpers'
import { NombreMensajeAlertas } from '../../collection/constraint'

const Prestador = () => {
	const { idPrestador,setIdPrestador, nombrePrestador, setNombrePrestador} = useContext(PrestadorContext);
	const [tipoPrestadores, setTipoPrestadores] = useState([])

	const [provincias, setProvincias] = useState([])
	const [regimenes, setRegimenes] = useState([])
	const [tipoPrestador, setTipoPrestador] = useState(0)
	const [nombre, setNombre] = useState('')
	const [regimen, setRegimen] = useState(0)
	const [provincia, setProvincia] = useState('');
	const [lista, setLista] = useState()
	const [open, setOpen] = useState(false)
	const [prestadorActual, setPrestadorActual] = useState({
		codigoPrestador: null,
		nombre: null,
		especialidad: null,
		direccion: null,
		telefono: null,
		correo: null,
		tipoPrestador: null
	})
	const [detallePrestador, setDetallePrestador] = useState([])
	const [loading, setLoading] = useState(false)
	const [totalRegistrosDisponibles, setTotalRegistrosDisponibles] = useState(0)
	const navigate = useNavigate();
	const handlerTipoPrestador = (value) => setTipoPrestador(value)
	const handlerNombre = ({ target }) => setNombre(target.value)
	const handlerCloseModal = (_) => setOpen(false)

	const { enqueueSnackbar, closeSnackbar } = useSnackbar()
	const { handlerIsLoginPage,getAlertaPersonalizada, mostrarMensajeAlerta } = useContext(ConfigurationContext)

	const [RegimenProveedor, setRegimenProveedor] = useState();
	const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado)
	const isDark = infoAfiliado.isUltra && infoAfiliado.ultraDarkMode
	const isUltraLight = infoAfiliado.isUltra && !infoAfiliado.ultraDarkMode
	
	const acciones = [
		{
			icono: UseIconHooks('visibility', {
				style: { color: colors.primary }
			}),
			metodo: (value) => {
				setPrestadorActual(value)
				apiService.prestador
					.getDetallePrestador(value.codigoPrestador, value.tipoPrestador)
					.then((response) => {
						setDetallePrestador(response.data.result)
						setOpen(true)
						tipoPrestadores.map(x => {
							if(x.descripcion === value.especialidad.toUpperCase())
							{
								apiService.prestador.getRegimenPrestador(value.codigoPrestador,x.codigo)
								.then((response) => {
									setRegimenProveedor(response.data.result)
								})
								.catch(err => console.error(err))
							}
						})
						
					})
					.catch((err) => console.error(err))
			},
			label: 'Ver detalle'
		},
		{
			icono: UseIconHooks('money', {
				style: { color: colors.primary }
			}),
			metodo: (value) => verCoberturasProveedor(value),
			label: 'Ver servicios disponibles'
		}
	]

	useEffect(() => {
		handlerIsLoginPage(false)
		getAllProvincias();
		getAllTipoPrestadores();
		getAllRegimenes();
		validarParametrosDesdeCobertura();
		getAlertaPersonalizada();
		obtenerRegimenAfiliadoLogin();
	}, [])

	useEffect(() => {
		if(open === false)
		{
			setRegimenProveedor('')
		}
	},[open])

	const mostrarMensaje = (nota, tipo) => {

		enqueueSnackbar( nota, {
		  variant: tipo,
		  action: (key) => (
			<Button style={{ color: 'white', fontWeight: 'bold' }} onClick={() => closeSnackbar(key)}>
			  X
			</Button>
		  )
		})
  
    }
  
	const handlerSearchPrestador = (e) => {
		e.preventDefault();
		// Búsqueda pública: se permite consultar sin criterios y traer todos
		// los resultados paginados.
		setLoading(true);
		const params = {
			IdTipoCentro: tipoPrestador || 0,
			Nombre: nombre || "",
			IdRegimen: regimen || 0,
			IdProvincia: provincia || 0,
			IdPrestador: 0,
			NumeroDePagina: 1,
			RegistrosPorPagina: 10,
		};
		buscarPrestador(params);
	}

	const getAllProvincias = async() => {
		await apiService.drops.getAllProvincias()
		.then((res) =>{
			setProvincias(res.data.result)
		})
		.catch((err) => console.error(err))
	}

	const getAllRegimenes = async() => {
		await apiService.drops.getAllRegimenes()
		.then((res) => {
			setRegimenes(res.data.result || [])
		})
		.catch((err) => console.error(err))
	}

	const getAllTipoPrestadores = async() => {
		await apiService.drops
			.getAllTipoPrestadores()
			.then((response) => {
				response.data.result.unshift({
					codigo: '',
					descripcion: 'TODOS LOS TIPOS DE PRESTADORES'
				})
				setTipoPrestadores(response.data.result)
			})
			.catch((err) => console.error(err))
	}

	const TitlePrestador = (
		<>
			<CustomLabel style={{ ...labelTitlePrestador }}>Red de Prestadores de Servicios de Salud</CustomLabel>
			<Divider />
			<br />
			<br />
		</>
	)

	useSetTitlePage(TitlePrestador)

	const buscarPrestador = async(params) => {
		setLoading(true)
		await apiService.prestador
		.getAllPrestadores(params)
		.then((response) => {
			if (response.data.result.length === 0) 
			{
				setLista([])
				mostrarMensaje(mostrarMensajeAlerta(NombreMensajeAlertas.PRESTADOR_CONSULTA_NOFOUND),'warning')
				
			}
			else
			{	
				setTotalRegistrosDisponibles(response.data.result.cantidadRegistros)
				setLista(response.data.result.data,response.data.result.data)
			}
			setLoading(false)
		})
		.catch((err) => {
			setLoading(false)
			mostrarMensaje('Favor intente más tarde.','error')
			console.error(err)
		})
	}

	const validarParametrosDesdeCobertura = () => {
		if(idPrestador){
			setNombre(nombrePrestador)
			const IdPrestador = idPrestador
			buscarPrestador({IdPrestador})
			setIdPrestador(0)
			setNombrePrestador('')
		}
	}

	const handlerPage = (NumeroDePagina, RegistrosPorPagina) =>{
		// Se preservan los filtros activos al paginar/cambiar tamaño de página.
		setLoading(true);
		buscarPrestador({
			IdTipoCentro: tipoPrestador || 0,
			Nombre: nombre || "",
			IdRegimen: regimen || 0,
			IdProvincia: provincia || 0,
			IdPrestador: 0,
			NumeroDePagina,
			RegistrosPorPagina,
		});
	}

	const validateScreenSizeLarge = (isXs, isMd) => {
		let ret = true;

		if(isXs){
			ret = false;
		}
		if(isMd){
			ret = false;
		}

		return ret;
	}

	const validateScreenSizeSmall = (isXs, isMd) => {
		let ret = false;

		if(isXs){
			ret = true;
		}
		if(isMd){
			ret = true;
		}

		return ret;
		
	}

	const verCoberturasProveedor = (value) => {
		setIdPrestador(value?.codigoPrestador)
        setNombrePrestador(value?.nombre)
        navigate(`/consulta/cobertura`);
	}

	const obtenerRegimenAfiliadoLogin = () => {
		const Regimen = infoAfiliado.regimen
		let regimen = 0
		switch (Regimen) {
			case "SUBSIDIADO": regimen = 1; break;
			case "CONTRIBUTIVO": regimen = 2; break;
			case "VOLUNTARIOS COLECTIVOS": regimen = 5; break;
			default: break;
		}
		setRegimen(regimen)
	}

	return (
		<>
		<form onSubmit={handlerSearchPrestador}>
			<Box sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: isDark ? '0 4px 24px rgba(0,0,0,0.5)' : '0 2px 10px rgba(0,0,0,0.12)', mb: 3, border: isDark ? `1px solid ${colors.ultraAccentBorder}` : isUltraLight ? `1px solid ${colors.ulBorder}` : undefined }}>
				<Box sx={{ backgroundColor: isDark ? colors.ultraAccent : isUltraLight ? colors.ulCardDark : colors.primary, py: 2, textAlign: 'center' }}>
					<Typography style={{ color: 'white', fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: 18, letterSpacing: 0.5 }}>
						Consulta Red de Prestadores
					</Typography>
				</Box>
				<Box sx={{ backgroundColor: isDark ? colors.ultraMid : 'white', px: 4, py: 3 }}>
					<Grid container spacing={2} alignItems='flex-end'>
						<Grid item md={3} xs={12}>
							<Typography style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, color: isDark ? colors.ultraAccentLight : colors.gray, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>
								Régimen
							</Typography>
							<FormControl fullWidth>
								<Select
									id="select-regimen-prestador"
									value={regimen}
									displayEmpty
									onChange={(event) => setRegimen(event.target.value)}
									style={{ fontFamily: 'Montserrat', backgroundColor: isDark ? colors.ultraSurface : 'white', color: isDark ? colors.ultraSilver : undefined, height: 48, borderRadius: 8 }}
									sx={isDark ? { '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.ultraBorder }, '& .MuiSvgIcon-root': { color: colors.ultraSilver } } : {}}
								>
									<MenuItem value={0}>--Todos--</MenuItem>
									{regimenes.map((item) => (
										<MenuItem id={createIdTag('select-regimen', item.descripcion)} key={item.codigo} value={item.codigo}>
											{item.descripcion}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item md={3} xs={12}>
							<Typography style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, color: isDark ? colors.ultraAccentLight : colors.gray, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>
								Tipo de Prestador
							</Typography>
							<FormControl fullWidth>
								<Select
									id="select-tipo-prestador"
									value={tipoPrestador}
									displayEmpty
									onChange={(event) => handlerTipoPrestador(event.target.value)}
									style={{ fontFamily: 'Montserrat', backgroundColor: isDark ? colors.ultraSurface : 'white', color: isDark ? colors.ultraSilver : undefined, height: 48, borderRadius: 8 }}
									sx={isDark ? { '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.ultraBorder }, '& .MuiSvgIcon-root': { color: colors.ultraSilver } } : {}}
								>
									<MenuItem value={0}>--Todos--</MenuItem>
									{tipoPrestadores.filter(t => t.codigo !== '').map((item) => (
										<MenuItem id={createIdTag('select', item.descripcion)} key={item.codigo} value={item.codigo}>
											{item.descripcion}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item md={3} xs={12}>
							<Typography style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, color: isDark ? colors.ultraAccentLight : colors.gray, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>
								Provincia
							</Typography>
							<Autocomplete
								id="select-provincia"
								fullWidth
								options={provincias}
								getOptionLabel={(option) => option.descripcion || ''}
								value={provincia ? provincias.find(item => item.codigo === provincia) || null : null}
								onChange={(event, newValue) => setProvincia(newValue ? newValue.codigo : '')}
								sx={{
									'& .MuiInputBase-root': { height: 48, borderRadius: '8px', fontFamily: 'Montserrat', backgroundColor: isDark ? colors.ultraSurface : undefined, color: isDark ? colors.ultraSilver : undefined },
									'& .MuiOutlinedInput-notchedOutline': isDark ? { borderColor: colors.ultraBorder } : {},
									'& .MuiAutocomplete-endAdornment': { top: '50%', transform: 'translateY(-50%)' },
									'& .MuiSvgIcon-root': isDark ? { color: colors.ultraSilver } : {},
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										placeholder='--Todos--'
										sx={isDark ? { '& input': { color: colors.ultraSilver }, '& input::placeholder': { color: 'rgba(176,176,176,0.5)' } } : {}}
									/>
								)}
							/>
						</Grid>
						<Grid item md={3} xs={12}>
							<Typography style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, color: isDark ? colors.ultraAccentLight : colors.gray, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>
								Nombre
							</Typography>
							<TextField
								id="field-nombre-prestador"
								fullWidth
								placeholder='Buscar por nombre...'
								value={nombre}
								onChange={handlerNombre}
								sx={{
									'& .MuiInputBase-root': { height: 48, borderRadius: '8px', fontFamily: 'Montserrat', backgroundColor: isDark ? colors.ultraSurface : undefined, color: isDark ? colors.ultraSilver : undefined },
									'& .MuiOutlinedInput-notchedOutline': isDark ? { borderColor: colors.ultraBorder } : {},
									'& input::placeholder': isDark ? { color: 'rgba(176,176,176,0.5)' } : {},
								}}
							/>
						</Grid>
						<Grid item md={3} xs={12}>
							<Button
								id="btn-buscar-prestador"
								fullWidth
								type="submit"
								variant='contained'
								startIcon={UseIconHooks('search', { style: { color: 'white' } })}
								style={{ backgroundColor: isDark ? colors.ultraAccent : isUltraLight ? colors.ulCardDark : colors.primary, fontFamily: 'Montserrat', fontWeight: 'bold', textTransform: 'initial', height: 48, borderRadius: 8, fontSize: 15 }}
							>
								Consultar
							</Button>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</form>
			
			<Grid container spacing={3}>
				<Grid item xs={12} marginTop={3}>
					<CustomTable columns={columnasPrestador} acciones={acciones} rows={lista} handlerPage={handlerPage} totalDisponibles={totalRegistrosDisponibles}/>
				</Grid>
			</Grid>
			<ModalLoading open={loading} onCloseHandler={() => setLoading(false)} />
			<DialogDetallePrestador open={open} handlerCloseModal={handlerCloseModal} prestador={prestadorActual} detalle={detallePrestador} regimenes={RegimenProveedor}/>
		</>
	)
}

export default Prestador
